exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-exhibition-page-tsx": () => import("./../../../src/templates/exhibition-page.tsx" /* webpackChunkName: "component---src-templates-exhibition-page-tsx" */),
  "component---src-templates-project-page-tsx": () => import("./../../../src/templates/project-page.tsx" /* webpackChunkName: "component---src-templates-project-page-tsx" */)
}

